import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CountryRegionData } from 'react-country-region-selector';

import utils from '../utils/utils';
import PriceFormatter from '../components/priceFormatter';
import { FormattedMessage, useIntl } from 'react-intl';
import PREFERRED_PRICE_DISPLAY from '../components/constants/preferredPriceDisplay';

const MarketplaceViewItem = ({ item, onItemClick, marketplace }) => {
  const image = getItemImage(item);
  const location = getItemAddress(item);
  const dateDay = utils.getDateFromString(item.dateCreated).format('DD');
  const dateMonth = utils.getDateFromString(item.dateCreated).format('MMM');

  const showUnitPrice =
    item.priceFields.unitPrice && item.priceFields.preferredPriceDisplay === PREFERRED_PRICE_DISPLAY.unitPrice;

  const { formatMessage } = useIntl();

  const itemContent = (
    <div className="marketplace-view-item">
      {image}
      <div className="marketplace-view-item__content">
        <h5 className="marketplace-view-item__content-name m-b-1">{utils.getItemName(item, formatMessage)}</h5>
        <p className="marketplace-view-item__content-description d-none d-sm-block m-b-2">{item.shortDescription}</p>
        <div className="marketplace-view-item__content-address">{location}</div>
        <div className="marketplace-view-item__content-price">
          <strong>
            {item.priceFields.comparedToPrice ? (
              <>
                <s className="m-r-1">
                  <PriceFormatter price={item.priceFields.comparedToPrice} currency={item.priceFields.currency} />
                </s>
                <span className="text-danger">
                  <PriceFormatter price={item.priceFields.price} currency={item.priceFields.currency} />
                </span>
              </>
            ) : (
              <PriceFormatter price={item.priceFields.price} currency={item.priceFields.currency} />
            )}{' '}
            {showUnitPrice ? <>/ {item.priceFields.standardUnitQuantity} kg</> : ''}
          </strong>
        </div>
      </div>
      <div className="marketplace-view-item__date text-center">
        <small>
          {dateDay}
          <br />
          {dateMonth}
        </small>
      </div>
      {item.isPrivate ? (
        <div className="marketplace-view-item__overlay">
          <h4 className="marketplace-view-item__overlay-content text-center">
            <FormattedMessage id={'marketplace.view.items.item.hidden'} />
          </h4>
        </div>
      ) : (
        ''
      )}
      <div className="marketplace-view-item__edit">
        <Link className="btn btn-small btn-primary" to={`/marketplaceAdmin/${marketplace.id}/item/edit/${item.id}`}>
          <FormattedMessage id={'marketplace.view.items.item.edit'} />
        </Link>
      </div>
    </div>
  );

  if (utils.isFunction(onItemClick)) {
    return (
      <div className="marketplace-view-item-wrapper" onClick={onItemClick}>
        {itemContent}
      </div>
    );
  } else {
    return <Link to={'/item/' + item.id}>{itemContent}</Link>;
  }
};

function getItemImage(item) {
  const stock = item.stock ? (
    <div className="marketplace-view-item__image-stock">
      <FormattedMessage id={'marketplace.view.items.item.stock'} />:{' '}
      <span className={`text-semi-bold ${item.stock <= item.stockWarning ? 'text-danger' : ''}`}>{item.stock}</span>
    </div>
  ) : (
    ''
  );

  if (item.images.length) {
    const imageStyle = {
      backgroundImage: 'url(' + item.images[0].thumbnailImage + ')',
    };

    return (
      <div className="marketplace-view-item__image m-b-3" style={imageStyle}>
        {stock}
      </div>
    );
  } else {
    return <div className="marketplace-view-item__no-image m-b-3">{stock}</div>;
  }
}

function getItemAddress(item) {
  if (!item.address || !item.address.country) {
    return '';
  }

  const country = CountryRegionData.find((country) => country[1] === item.address.country);

  return country ? (
    <small>
      <i className="fa fa-map-marker" /> {country[0]}
    </small>
  ) : (
    ''
  );
}

MarketplaceViewItem.propTypes = {
  item: PropTypes.object.isRequired,
  marketplace: PropTypes.object.isRequired,
  onItemClick: PropTypes.func,
};

MarketplaceViewItem.defaultProps = {};

export default MarketplaceViewItem;
